/* eslint-disable react/jsx-no-constructed-context-values */
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Homepage from "./home";
import Dashboard from "./dashboard/Dashboard";
import OMSDashboard from "./dashboard/OMSDashboard";
import RoyaltyReconDashboard from "./dashboard/RoyaltyReconDashboard";
import OrderRedrive from "./redrive/OrderRedrive";
import PaymentRedrive from "./redrive/PaymentRedrive";
import DlqRedrive from "./dlq/DlqRedrive";
import { UatPortal } from "./uat/UatPortal";
import { AnalyticsProvider } from "./dashboard/AnalyticsProvider";

// Redirects to `pathname` while preserving the original query string so
// bookmarked links with filters/views/stage params keep working.
function RedirectPreservingQuery({ pathname }: { pathname: string }) {
  const { search } = useLocation();
  return <Navigate to={{ pathname, search }} replace />;
}

export default function App() {
  const queryClient = new QueryClient();

  return (
    <AnalyticsProvider>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/find" element={<Homepage />} />
          <Route path="/saved" element={<Homepage />} />
          <Route path="/dashboard/dlq" element={<Dashboard />} />
          <Route path="/dashboard/oms" element={<OMSDashboard />} />
          <Route path="/dashboard/oms/:product" element={<OMSDashboard />} />
          <Route
            path="/dashboard/royalty-recon"
            element={<RoyaltyReconDashboard />}
          />
          <Route
            path="/dashboard/royalty-recon/:product"
            element={<RoyaltyReconDashboard />}
          />
          <Route path="/dashboard/uat" element={<UatPortal />} />
          {/* Redirect legacy bookmarked URLs to canonical routes */}
          <Route
            path="/dashboard"
            element={<RedirectPreservingQuery pathname="/dashboard/dlq" />}
          />
          <Route
            path="/uat"
            element={<RedirectPreservingQuery pathname="/dashboard/uat" />}
          />
          <Route path="/redrive" element={<OrderRedrive />} />
          <Route path="/payment-redrive" element={<PaymentRedrive />} />
          <Route path="/dlq-redrive" element={<DlqRedrive />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </QueryClientProvider>
    </AnalyticsProvider>
  );
}
